<template>
  <div class="table-responsive">
    <table class="table">
      <thead>
        <tr>
          <th scope="col">Agência</th>
          <th scope="col">Autorização</th>
          <th scope="col">Banco</th>
          <th scope="col">Cheque</th>
          <th scope="col">Documento</th>
          <th scope="col" class="text-left text-md-right">Val. Cheque</th>
          <th scope="col" class="text-left text-md-right">Val. Garantido</th>
          <th scope="col" class="text-left text-md-right">Val. Ressarcido</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in items" :key="index">
          <td>{{ item.agencia }}</td>
          <td>{{ item.autoriz }}</td>
          <td>{{ item.banco }}</td>
          <td>{{ item.cheque }}</td>
          <td>{{ item.documento }}</td>
          <td class="text-left text-md-right">
            {{ item.vlrcheque | currency }}
          </td>
          <td class="text-left text-md-right">
            {{ item.vlrrecuperado | currency }}
          </td>
          <td class="text-left text-md-right">
            {{ item.vlrressarcido | currency }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  name: "List",
  props: {
    items: Array,
  },
  filters: {
    currency(valor) {
      if (isNaN(valor)) {
        return "-";
      } else {
        var formatter = new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        });
        return formatter.format(valor);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_mixins.scss";
th {
  color: #6c757d;
  font-weight: 300;
  font-size: 14px;
  text-transform: uppercase;
  border: none;
}
td {
  color: #212529;
  font-weight: 300;
  font-size: 16px;
  text-transform: uppercase;
  border-color: #e9ecef;
}
</style>
